module.exports = __webpack_public_path__ + "img/Crystal_Logo_SVG.b84d8185.svg";